<template>
  <th>
    <slot />
  </th>
</template>

<style lang="postcss" scoped>
thead th {
  @apply text-gray-500 p-2 pt-0 align-bottom font-semibold first:pl-0 last:pr-0;
}

.table-border thead th {
  @apply border p-2;
}
</style>
